RivalIQ.apps.AccountSettings.module('views', function (views, App, Backbone, Marionette, $, _, moment, s) {

    'use strict';

    function loadDataBySource(source, model) {
        return $.when();
    }

    const DisconnectTokenMixin = views.DisconnectTokenMixin = {
        _getDisconnectDetails: function () {
            const me = this;
            let disconnectWarning = null;
            let disconnectTitle = null;
            let disconnectMsg = null;

            const channel = me.model.get('channel');
            if (channel === RivalIQ.enums.channels.FACEBOOK) {
                disconnectWarning = me.getFacebookDisconnectWarning();
                disconnectTitle = RivalIQ.strings.facebook_connection_disconnect_warning_title;
            } else if (channel === RivalIQ.enums.channels.LINKEDIN) {
                disconnectTitle = RivalIQ.strings.linked_in_connection_disconnect_warning_title;
                disconnectWarning = RivalIQ.strings.linked_in_connection_disconnect_warning;
            } else if (channel === RivalIQ.enums.channels.TWITTER) {
                disconnectMsg = RivalIQ.strings.twitter_connection_disconnect_warning;
            } else if (channel === RivalIQ.enums.channels.TIKTOK) {
                disconnectMsg = RivalIQ.strings.tiktok_connection_disconnect_warning;
            }

            return {
                warning: disconnectWarning,
                title: disconnectTitle,
                message: disconnectMsg
            };
        },

        _execDisconnect: function () {
            const me = this;

            me.ui.disconnectBtn.button('loading');

            const channel = me.model.get('channel');
            const uniqueKeyPart = me.model.get('uniqueKeyPart') || me.model.get('unique_key_part');

            const options = {
                type: 'DELETE',
                url: `/api/oauth/${channel}`,
                data: {
                    uniqueKeyPart: uniqueKeyPart
                }
            };

            $.ajax(options)
                .done(function () {
                    // single token channel
                    me._parentView().tokenDisconnected = true;
                    if (me.model.disconnect) {
                        me.model.disconnect();
                        me.render();
                    } else {
                        // multi token channel
                        me.options.curation.disconnect(uniqueKeyPart);
                        // this will trigger the rerendering of modal and channel row in connected accounts
                        me.trigger('child:deleted');
                    }
                })
                .fail(function () {
                    RivalIQ.execute('alert:danger', 'An error occurred, please try again');
                    me.ui.disconnectBtn.button('reset');
                });
        },

        disconnect: function () {
            const me = this;

            if (RivalIQ.state.account.isImpersonated()) {
                RivalIQ.execute('alert:warning', 'Not disconnecting a token while impersonating.');
                return;
            }

            const disconnect = me._getDisconnectDetails();

            // new text under connection button
            if (disconnect.message) {
                me.displayDisconnectMsg(disconnect.message);
            } else if (disconnect.warning) {
                // disconnect warning modal
                const modalInfo = {
                    contentHtml: disconnect.warning,
                    actions: [
                        {
                            html: 'Cancel',
                            className: 'btn btn-default',
                            attributes: {
                                type: 'button',
                                'data-dismiss': 'modal'
                            }
                        },
                        {
                            html: 'Disconnect',
                            className: 'btn btn-danger',
                            events: {
                                click: function () {
                                    me._execDisconnect();
                                }
                            },
                            attributes: {
                                type: 'button',
                                'data-dismiss': 'modal'
                            }
                        }
                    ]
                };

                if (disconnect.title) {
                    modalInfo.information = {
                        title: disconnect.title
                    };
                }

                RivalIQ.execute('show:modal', modalInfo);
            } else {
                me._execDisconnect();
            }
        }
    };

    views.AccountConnectionItem = RivalIQ.views.ItemView.mixin({
        tagName: 'tr',
        className: 'account-connection',
        template: '#accountConnectionTemplate',

        behaviors: {
            AttributeBuilder: {}
        },

        mixins: [DisconnectTokenMixin],

        ui: {
            disconnectBtn: '.x-disconnect',
            resyncLink: '.x-resync-connection',
            connectedPages: '.x-connected-pages'
        },

        events: {
            'click @ui.disconnectBtn': 'disconnect',
            'click @ui.resyncLink': 'resync',
            'click .btn-manage-tiktok': 'showMultiTokenModal',
            'click .btn-manage-twitter': 'showMultiTokenModal',
            'click @ui.connectedPages': 'showConnectedPagesModal'
        },

        initialize: function () {
            const me = this;
            const curation = me.getOption('curation');
            const fromReconnect = curation.getProp('fromReconnect');
            const fromPermissions = curation.getProp('fromPermissions');
            const buttonSource = curation.getProp('buttonSource');
            const screenName = curation.getProp('screenName');

            let alertMessage;
            if (fromReconnect) {
                alertMessage = 'We reconnected your ';
            } else if (fromPermissions) {
                alertMessage = 'Permissions granted to your ';
            }

            const sources = RivalIQ.enums.sources;
            const reconnectSources = [sources.LINKEDIN, sources.TWITTER];
            if (RivalIQ.state.account.inBeta('tiktok_private') === true) {
                reconnectSources.push(sources.TIKTOK);
            }
            if (_.includes(reconnectSources, Number(buttonSource)) && fromReconnect) {
                const channelName = RivalIQ.enums.sourceDetails[buttonSource].channel;
                RivalIQ.data.privateMetadata.fetch(_.extend({
                    channel: channelName
                }, curation.getProps()))
                    .then(function (results) {
                        const companyNames = _.map(results.companies, function (company) {
                            return company.name;
                        });
                        if (screenName) {
                            alertMessage = `We refreshed the connection to ${screenName} for ${RivalIQ.enums.sourceDetails[buttonSource].name}.`;
                            RivalIQ.execute('alert:info', alertMessage);
                        } else {
                            me.popTokenRefreshedToast(companyNames, alertMessage + RivalIQ.enums.sourceDetails[buttonSource].name);
                        }
                    });
            } else if (fromReconnect || fromPermissions) {
                // get the names of the facebook pages this account has access to now
                // BUGBUG this shows only facebook, but the action affects instagram as well...
                $.get('/api/account/facebook/tokensAccess')
                    .then(function (results) {
                        const fbPages = results[RivalIQ.enums.sources.FACEBOOK] || {};
                        const fbPageNames = _(fbPages)
                            .values()
                            .sortBy('name')
                            .map('name')
                            .value();
                        me.popTokenRefreshedToast(fbPageNames, alertMessage + RivalIQ.enums.sourceDetails[RivalIQ.enums.sources.FACEBOOK].name);
                    });
            }

            // clear these props
            curation.setProps({
                fromReconnect: null,
                fromPermissions: null,
                buttonSource: null,
                screenName: null,
                newToken: null
            });
        },

        popTokenRefreshedToast: function (names, alertMessage) {
            const pagesList = $.tagHtml('ul', {
                html: _.map(names, function (name) {
                    return $.tagHtml('li', {
                        text: name
                    });
                }).join(' ')
            });

            // privateMetadata won't return linkedin company pages that aren't in this landscape
            alertMessage += _.isEmpty(names) ? ' pages.' : ` Pages:${pagesList}`;
            RivalIQ.execute('alert:info', alertMessage);
        },

        serializeData: function () {
            const me = this;
            const model = me.model;
            const source = model.get('source');

            let secondaryChannel = null;
            let secondaryChannelFontIcon = null;
            let reconnectUrl = null;
            let connectionExplainer;
            const oauthUrl = RivalIQ.channels.getOAuthUrl(source);
            if (source === RivalIQ.enums.sources.FACEBOOK) {
                secondaryChannel = RivalIQ.enums.sourceDetails[RivalIQ.enums.sources.INSTAGRAM].name;
                secondaryChannelFontIcon = RivalIQ.enums.sourceDetails[RivalIQ.enums.sources.INSTAGRAM].fontIcon;
                reconnectUrl = oauthUrl + encodeURIComponent('/?fromReconnect=true');
                connectionExplainer = [
                    '<div>View connected <a class="x-connected-pages" data-source="',
                    RivalIQ.enums.sources.FACEBOOK,
                    '">Facebook</a> and <a class="x-connected-pages" data-source="',
                    RivalIQ.enums.sources.INSTAGRAM_INSIGHTS,
                    '">Instagram</a> pages.</div>'
                ].join('');
            } else if (source === RivalIQ.enums.sources.LINKEDIN) {
                reconnectUrl = oauthUrl + encodeURIComponent(`/?fromReconnect=true&buttonSource=${RivalIQ.enums.sources.LINKEDIN}`);
                connectionExplainer = [
                    '<div>View connected <a class="x-connected-pages" data-source="',
                    RivalIQ.enums.sources.LINKEDIN,
                    '">LinkedIn</a> pages.</div>'
                ].join('');
            }

            let expiresMsg = '';
            if (model.expiresAt()) {
                expiresMsg = `Expires ${moment(model.expiresAt()).fromNow()}`;
            }

            return _.extend(model.toJSON(), {
                oauthUrl: oauthUrl,
                expiresMsg: expiresMsg,
                hasConnection: model.hasConnection(),
                hasConnectedPages: Boolean(connectionExplainer),
                connectionExplainer: connectionExplainer || '',
                numTokens: model.getUniqueConnections().length,
                secondaryChannel: secondaryChannel,
                secondaryChannelFontIcon: secondaryChannelFontIcon,
                reconnectUrl: reconnectUrl
            });
        },

        loadData: function () {
            const me = this;
            const model = me.model;
            return loadDataBySource(model.get('source'), model);
        },

        showMultiTokenModal: function () {
            const me = this;

            RivalIQ.execute('show:modal', new views.MultiTokenConnectionModal(
                {
                    model: me.model,
                    parentItem: me
                }
            ));
        },

        showConnectedPagesModal: function (e) {
            const me = this;

            const source = $(e.currentTarget).data('source');

            if (source === RivalIQ.enums.sources.LINKEDIN) {
                me.showLinkedInConfigurationModal();
            } else {
                me.model.set('source', source);
                RivalIQ.execute('show:modal', new views.ConnectedPagesModal(
                    {
                        model: me.model
                    }
                ));
            }
        },

        showLinkedInConfigurationModal: function () {
            const me = this;

            const props = {
                landscapeId: RivalIQ.state.landscape.get('id'),
                channel: me.model.get('channel')
            };

            RivalIQ.data.privateMetadata.fetch(props, {
                force: true
            }).then(function (metadata) {
                const accountPresences = me.privateMetadataToAccountPresence(metadata);
                const accountCompanies = metadata.accountCompanies;

                RivalIQ.execute('show:modal', new RivalIQ.apps.Insights.views.LinkedInPresenceConfigurationModal({
                    model: me.model,
                    accountPresences: accountPresences,
                    accountCompanies: accountCompanies,
                    fromConnectedAccounts: true
                }));
            });
        },

        privateMetadataToAccountPresence: function (metadata) {
            // from private filters._linkedinProcessMetadata
            const accountPresences = _.map(metadata.linkedInPresences, function (company) {
                return _.extend({}, company, {
                    id: company.joinId,
                    companyId: company.id,
                    linked_in_presence_id: company.presenceId
                });
            });

            // all presences both mapped and unassociated w valid tokens
            const allAccountPresences = _.union(accountPresences, metadata.unassociatedPresences);

            return new RivalIQ.apps.Insights.collections.LinkedInPresences(allAccountPresences);
        },

        getFacebookDisconnectWarning: function () {
            const me = this;
            const curation = me.getOption('curation');
            const fbTokens = curation.tokens;

            const hasInstagramInsightsToken = fbTokens.tokenWithInstagramInsightsExists();
            const facebookFeatures = [
                {
                    active: fbTokens.tokenWithFbInsightsExists(),
                    name: 'Facebook Insights'
                },
                {
                    active: fbTokens.tokenWithFbAdsReadExists(),
                    name: 'Facebook Ads'
                },
                {
                    active: hasInstagramInsightsToken,
                    name: 'Instagram Insights'
                }
            ];
            const activeFeatures = _.reduce(facebookFeatures, function (memo, feature) {
                return (feature.active ? memo.concat(feature.name) : memo);
            }, []);

            let warning = '';
            if (hasInstagramInsightsToken) {
                warning += 'Rival IQ will not be able to access and report on new Instagram Stories. <br><br>';
            }
            warning += `Rival IQ will ${_.isEmpty(warning) ? '' : 'also '}no longer report on ${s.toSentenceSerial(activeFeatures)} data for companies associated with your token.`;
            return warning;
        },

        templateHelpers: function () {
            return {
                impersonated: RivalIQ.state.account.isImpersonated
            };
        },

        resync: function (event) {
            if (RivalIQ.state.account.isImpersonated()) {
                RivalIQ.execute('alert:warning', 'Not resyncing a token while impersonating.');
                event.preventDefault();
                return false;
            }
        }
    });

}, window.moment, window.s);
